import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from '../../core-ui/Tooltip';
import { CardComponent } from './Card.component';
import { CardDropdownComponent } from './CardDropdown.component';
import { CardInnerComponent } from './CardInner.component';
import { CardToggleComponent } from './CardToggle.component';
import { PreviewCardComponent } from './PreviewCard.component';

export const CardsModuleExports = [
    CardComponent,
    CardDropdownComponent,
    CardToggleComponent,
    PreviewCardComponent
];

@NgModule({
    imports: [CommonModule, RouterModule, TooltipModule],
    declarations: [...CardsModuleExports, CardInnerComponent],
    exports: [...CardsModuleExports],
    providers: []
})
export class CardsModule {}
